import { SET_SWIFT_USERS_DATA } from "../actionTypes";
import { User } from "../../Types/PrismaSwift";

export const setSwiftUsersDataAction = (payload: User[] | []) => {
  return {
    type: SET_SWIFT_USERS_DATA as typeof SET_SWIFT_USERS_DATA,
    payload: payload,
  };
};
